import React from "react";
import Tool from "./Tool";
import { observer } from "mobx-react";
import { observable } from "mobx";

@observer
export default class ZoomTool extends Tool {
  @observable dragging = false;
  @observable dragStart = {};
  @observable selection = {};
  selecting = false;
  moving = false;

  @observable showAxis = "none";

  constructor(props) {
    super(props, 20, 20, "zoom", true);
  }

  registerEvents() {
    return {
      mousemove: this.mouseMove.bind(this),
      mousedown: this.mouseDown.bind(this),
      mouseup: this.mouseUp.bind(this)
    };
  }

  mouseDown(e) {
    if (e.button === 0) {
      e.preventDefault();
      e.stopPropagation();

      this.dragging = true;
      this.selecting = true;
      this.dragStart = {
        x: e.clientX,
        y: e.clientY
      };
    }
  }

  startMove(x, y) {
    this.dragging = true;
    this.moving = true;
    this.dragStart = {
      x,
      y
    };
  }

  mouseMove(e) {
    if (this.dragging) {
      e.preventDefault();
      e.stopPropagation();
      const deltaX = e.clientX - this.dragStart.x;
      const deltaY = e.clientY - this.dragStart.y;

      if (this.selecting) {
        let x, y, w, h;

        if (deltaX < 0) {
          x = e.clientX;
          w = this.dragStart.x - x;
        } else {
          x = this.dragStart.x;
          w = deltaX;
        }
        if (deltaY < 0) {
          y = e.clientY;
          h = this.dragStart.y - y;
        } else {
          y = this.dragStart.y;
          h = deltaY;
        }
        this.selection = {
          top: y,
          left: x,
          width: w,
          height: h,
          hidden: false
        };
      }
    }
  }

  mouseUp(e) {
    if (this.dragging) {
      this.dragging = false;

      if (this.selecting) {
        this.selecting = false;
        this.comeFromSelection = true;
      }
      if (this.moving) this.moving = false;

      this.selection.hidden = true;
      this.zoomToArea()
    }
  }

  zoomToArea() {
    const c = this.toolbar.document.props.parent;
    c.zoomInArea({
      x: this.selection.left,
      y: this.selection.top,
      w: this.selection.width,
      h: this.selection.height
    });
  }

  renderAction() {
    return (
      <React.Fragment key={99}>
        <div
          style={{
            position: "absolute",
            top: this.selection.top,
            left: this.selection.left,
            width: this.selection.width,
            height: this.selection.height,
            background: "rgba(71, 100, 249, .2)",
            border: "1px solid rgb(71, 100, 249)",
            visibility: this.selection.hidden ? "hidden" : "visible"
          }}
        />
        <div
          style={{
            position: "absolute",
            top: this.selection.top + this.selection.height / 2 - 1,
            left: this.selection.left + this.selection.width / 2 - 1,
            width: 2,
            height: 2,
            background: "red",
            visibility: this.selection.hidden ? "hidden" : "visible"
          }}
        />
      </React.Fragment>
    );
  }

  renderTool() {
    return (
      <g>
        <circle cx={8} cy={8} r={7} strokeWidth={2} />
        <line x1={13} y1={13} x2={20} y2={20} strokeWidth={2} />
      </g>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/tools/ZoomTool.js